import ScrollReveal from 'scrollreveal'

export default {
  init: () => {
    const variants = {
      'fade-up': {
        distance: '30%',
        origin: 'bottom',
      },
      'fade-left': {
        distance: '30%',
        origin: 'right',
      },
      'fade-right': {
        distance: '30%',
        origin: 'left',
      },
      grow: {
        origin: 'center',
        scale: 0.2,
        duration: 1000,
        delay: 600,
      },
      zoom: {
        origin: 'center',
        scale: 0.5,
      },
      fade: {
        duration: 1000,
      },
    }

    document.querySelectorAll('[data-sr-group]').forEach((group) => {
      if (group.closest('[data-disable-animations]')) return

      const common = {
        interval: 150,
        duration: 800,
      }

      for (const [key, opts] of Object.entries(variants)) {
        const els = group.querySelectorAll(`[data-sr="${key}"]`)

        if (els.length) {
          ScrollReveal().reveal(els, {
            ...common,
            ...opts,
          })
        }
      }

      group.querySelectorAll('[data-sr="fade-content-up"]').forEach((content) => {
        const els = content.querySelectorAll('*')

        ScrollReveal().reveal(els, {
          interval: 150,
          duration: 600,
          distance: '30%',
          origin: 'bottom',
        })
      })
    })

    window.addEventListener('beforeprint', () => {
      document.querySelectorAll('[data-sr]').forEach((el) => {
        el.style.opacity = 1
        el.style.transform = null
      })
    })
  },
}
